import { useMemo } from 'react';
import { useCanvasEntities } from '../stores/CanvasContext';

export function useExistingTaskIds(): Set<string> {
  const entities = useCanvasEntities();
  return useMemo(() => {
    const set = new Set<string>();
    for (const e of entities) {
      if (e.kind === 'task') set.add(e.id);
    }
    return set;
  }, [entities]);
}
